// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LpGEfXC9w4 {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.LpGEfXC9w4 h4 {
  line-height: 3em;
}
.LpGEfXC9w4 .t0qmeBeEPX {
  float: left;
  width: 100%;
}
.LpGEfXC9w4 .nJwKrEFNQo {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.LpGEfXC9w4 .nJwKrEFNQo:hover {
  cursor: pointer;
}
.LpGEfXC9w4 .nJwKrEFNQo:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.tDdhEWe4gd .vazcvBfliU:focus {
  outline: none;
}
.tDdhEWe4gd .vazcvBfliU.Q76Hbzjj_f.HSH6vpWCJq {
  background: #375A88;
}
.tDdhEWe4gd .vazcvBfliU.Q76Hbzjj_f.HSH6vpWCJq span {
  color: #fff;
}
.tDdhEWe4gd .HSH6vpWCJq {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.tDdhEWe4gd .HSH6vpWCJq:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.tDdhEWe4gd input {
  height: 38px;
  min-width: 220px;
}
.nJwKrEFNQo.UjEZfPUzgE {
  background: #410102;
}
.nJwKrEFNQo.yw1iYiOVt6 {
  background: #911318;
}
.nJwKrEFNQo.X0alf8mfSm {
  background: #D8293B;
}
.nJwKrEFNQo.XSAIR06Gw1 {
  background: #F2373C;
}
.nJwKrEFNQo.S3VE8EkUba {
  background: #FC4448;
}
.nJwKrEFNQo.Iwzx8w0qBu {
  background: #ED535E;
}
.nJwKrEFNQo.FvwiZrEXlc {
  background: #E34926;
}
.nJwKrEFNQo.JQ75WCxKpN {
  background: #FC562B;
}
.nJwKrEFNQo.mkfIRk92gC {
  background: #FC6722;
}
.nJwKrEFNQo.gWfQ5gcNJ6 {
  background: #FD7F24;
}
.nJwKrEFNQo.M7hA3Mt5dZ {
  background: #FD8D26;
}
.nJwKrEFNQo.AOjr8pLBTp {
  background: #EC9C3E;
}
.nJwKrEFNQo.xwGYJO1Jrk {
  background: #0e673a;
}
.nJwKrEFNQo.wMdZ4Hy3Zf {
  background: #208740;
}
.nJwKrEFNQo.jjnuzJAbfu {
  background: #239718;
}
.nJwKrEFNQo.HIwbi7DY3s {
  background: #55A84D;
}
.nJwKrEFNQo.JI4U4c25j6 {
  background: #4BBE5A;
}
.nJwKrEFNQo.X6v8HRHcLF {
  background: #0CCA6A;
}
.nJwKrEFNQo.Td4uNO2Naa {
  background: #0A3C64;
}
.nJwKrEFNQo.YiehK4yqqT {
  background: #0d487a;
}
.nJwKrEFNQo.N6fjuw8IvA {
  background: #10538d;
}
.nJwKrEFNQo.MfwQ0GfdhQ {
  background: #115A99;
}
.nJwKrEFNQo.pvebfviEJE {
  background: #3387E2;
}
.nJwKrEFNQo.Ikifj7dPNa {
  background: #1BA9CF;
}
.nJwKrEFNQo.Tzo7HbWHBv {
  background: #d27c02;
}
.nJwKrEFNQo.nTJiknTJj2 {
  background: #fb9402;
}
.nJwKrEFNQo.JyOMp1150v {
  background: #FD9B30;
}
.nJwKrEFNQo.ZCZYLuJFvy {
  background: #FDBE2D;
}
.nJwKrEFNQo.sOQYemU37P {
  background: #FED831;
}
.nJwKrEFNQo.rqHiSOLgem {
  background: #FFFD38;
}
.nJwKrEFNQo.dViZ1C9cKP {
  background: #2D215C;
}
.nJwKrEFNQo.GzP6_F_wGC {
  background: #483C83;
}
.nJwKrEFNQo.MH2IrSwm_5 {
  background: #58518d;
}
.nJwKrEFNQo.YBoq6_3Fax {
  background: #7068A9;
}
.nJwKrEFNQo.C0bGAUJewj {
  background: #7f78b2;
}
.nJwKrEFNQo.GBjXFOdcBT {
  background: #8f88bc;
}
.nJwKrEFNQo.x8XQfCw97k {
  background: #000;
}
.nJwKrEFNQo.QP58IDBOUa {
  background: #282626;
}
.nJwKrEFNQo.c2Gl0OvrMd {
  background: #242222;
}
.nJwKrEFNQo.PDpyHA2bbZ {
  background: #353838;
}
.nJwKrEFNQo.pS_8Vd2J_9 {
  background: #666;
}
.nJwKrEFNQo.PM_h7_vZKB {
  background: #999;
}
.PH_meFEZRs {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.PH_meFEZRs .WeQcZFcxKD {
  display: none;
}
.MuiDrawer-root .gPwirS6DMv {
  background: none;
}
.MuiDrawer-root .MuiDrawer-paper .k02FYkLS0c {
  background-color: #6E60BF;
  display: flex;
  flex-wrap: nowrap;
  height: 64px;
  position: relative;
  align-items: center;
  justify-content: space-between;
}
.MuiDrawer-root .MuiDrawer-paper .jrLnISuS3H {
  font-size: 12px;
}
.MuiDrawer-root .MuiDrawer-paper .k02FYkLS0c .al7f61Cn6Z {
  display: flex;
  align-items: center;
  margin: 0;
  background-color: transparent;
  min-width: auto;
}
.MuiDrawer-root .MuiDrawer-paper .k02FYkLS0c .YLns8XpTEX {
  margin: 0;
}
.MuiDrawer-root .MuiDrawer-paper .k02FYkLS0c .UvcxjveqN2 {
  display: flex;
  justify-content: flex-start;
  padding-right: 40px;
  flex-grow: 0;
}
.MuiDrawer-root .MuiDrawer-paper .k02FYkLS0c .UvcxjveqN2 .eD0HlazzW5 {
  display: flex;
  position: absolute;
  right: 50px;
}
.MuiDrawer-root .MuiDrawer-paper .yH8la806dK {
  border-radius: 0;
  padding: 6px;
  margin-right: 0;
  margin-top: 6px;
  background: #000;
  opacity: 0.2;
}
.MuiDrawer-root .MuiDrawer-paper .yH8la806dK .pulse-icon__ctn {
  margin-right: 0;
}
.MuiDrawer-root .MuiDrawer-paper .yH8la806dK .pulse-icon__ctn i {
  font-size: 10px;
}
.MuiDrawer-root .MuiDrawer-paper .yH8la806dK .h6d6S_ZJbz {
  display: none;
}
.MuiDrawer-root .MuiDrawer-paper .k02FYkLS0c h2.HVTlQ_piIt {
  font-size: 12px;
  font-weight: 700;
  line-height: 15px;
  margin-bottom: 0 !important;
}
.MuiDrawer-root .MuiDrawer-paper .k02FYkLS0c .Q6eM0pq8Rs {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 0;
  color: #FFF;
  height: 20px;
  position: absolute;
  right: 20px;
  top: 6px;
  width: 20px;
}
.MuiDrawer-root .MuiDrawer-paper .k02FYkLS0c .Q6eM0pq8Rs .ZTyktRaY4O {
  font-size: 10px;
}
.ScrollbarsCustom-Content {
  height: 100%;
}
.k02FYkLS0c.k02FYkLS0c button[data-testid="pulse-icon-button"] {
  border-radius: 4px;
}
.k02FYkLS0c.k02FYkLS0c button[data-testid="pulse-icon-button"]:hover {
  border-radius: 4px;
  background: #F2F2F2;
}
.k02FYkLS0c.k02FYkLS0c .omYuKbRwEW {
  position: absolute;
  right: 56px;
}
.k02FYkLS0c.k02FYkLS0c .rpBMnJsEQc {
  border-radius: 40px;
  height: 20px;
  display: flex;
  align-items: center;
  color: #18181A;
  border: 1px solid #CAC9CC;
  cursor: pointer;
  padding: 0 8px;
  background-color: white;
}
.k02FYkLS0c.k02FYkLS0c .rpBMnJsEQc span {
  color: #18181A;
  font-size: 11px;
  line-height: 16px;
}
.k02FYkLS0c.k02FYkLS0c .rpBMnJsEQc i {
  font-size: 12px;
}
.k02FYkLS0c.k02FYkLS0c .gEKAKLDz81 {
  padding: 0 4px;
  margin-top: 1px;
  height: auto;
}
.k02FYkLS0c.k02FYkLS0c .f8gfPVHOB1 {
  border: 1px solid #CAC9CC;
  border-radius: 40px;
}
.k02FYkLS0c.k02FYkLS0c .f8gfPVHOB1 > span {
  background-color: white;
}
.k02FYkLS0c.k02FYkLS0c .fakTmoEeqU {
  font-size: 11px;
  line-height: 16px;
}
.k02FYkLS0c.k02FYkLS0c .Q6IvXuNunS {
  color: #18181A;
}
.k02FYkLS0c.k02FYkLS0c .Cc60n1vcRA {
  display: flex;
  align-items: center;
}
.FQOKxnE16u {
  max-width: 240px;
  min-width: 240px;
  background: black;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  border-radius: 4px;
}
.FQOKxnE16u a.f3x152c4Qc {
  color: #fff;
  text-decoration: underline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
}
.FQOKxnE16u a.f3x152c4Qc:hover {
  color: #fff;
}
.FQOKxnE16u[data-placement^="bottom"] .gKHMw1k_Lo {
  left: 4px !important;
  top: -16px;
  transform: translateX(212px) rotate(180deg) !important;
  width: 16px;
  height: 16px;
}
.FQOKxnE16u[data-placement^="bottom"] .gKHMw1k_Lo::before {
  border-width: 8px 6px 0;
  border-top-color: black !important;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `LpGEfXC9w4`,
	"color-row": `t0qmeBeEPX`,
	"color-tile": `nJwKrEFNQo`,
	"picker-component": `tDdhEWe4gd`,
	"picker-element": `vazcvBfliU`,
	"active": `Q76Hbzjj_f`,
	"btn": `HSH6vpWCJq`,
	"red-1": `UjEZfPUzgE`,
	"red-2": `yw1iYiOVt6`,
	"red-3": `X0alf8mfSm`,
	"red-4": `XSAIR06Gw1`,
	"red-5": `S3VE8EkUba`,
	"red-6": `Iwzx8w0qBu`,
	"orange-1": `FvwiZrEXlc`,
	"orange-2": `JQ75WCxKpN`,
	"orange-3": `mkfIRk92gC`,
	"orange-4": `gWfQ5gcNJ6`,
	"orange-5": `M7hA3Mt5dZ`,
	"orange-6": `AOjr8pLBTp`,
	"green-1": `xwGYJO1Jrk`,
	"green-2": `wMdZ4Hy3Zf`,
	"green-3": `jjnuzJAbfu`,
	"green-4": `HIwbi7DY3s`,
	"green-5": `JI4U4c25j6`,
	"green-6": `X6v8HRHcLF`,
	"blue-1": `Td4uNO2Naa`,
	"blue-2": `YiehK4yqqT`,
	"blue-3": `N6fjuw8IvA`,
	"blue-4": `MfwQ0GfdhQ`,
	"blue-5": `pvebfviEJE`,
	"blue-6": `Ikifj7dPNa`,
	"yellow-1": `Tzo7HbWHBv`,
	"yellow-2": `nTJiknTJj2`,
	"yellow-3": `JyOMp1150v`,
	"yellow-4": `ZCZYLuJFvy`,
	"yellow-5": `sOQYemU37P`,
	"yellow-6": `rqHiSOLgem`,
	"purple-1": `dViZ1C9cKP`,
	"purple-2": `GzP6_F_wGC`,
	"purple-3": `MH2IrSwm_5`,
	"purple-4": `YBoq6_3Fax`,
	"purple-5": `C0bGAUJewj`,
	"purple-6": `GBjXFOdcBT`,
	"black-1": `x8XQfCw97k`,
	"black-2": `QP58IDBOUa`,
	"black-3": `c2Gl0OvrMd`,
	"black-4": `PDpyHA2bbZ`,
	"black-5": `pS_8Vd2J_9`,
	"black-6": `PM_h7_vZKB`,
	"picker-theme": `PH_meFEZRs`,
	"arrow-regular": `WeQcZFcxKD`,
	"MuiBackdrop-root": `gPwirS6DMv`,
	"drawer-header": `k02FYkLS0c`,
	"drawer-header__title--primary": `jrLnISuS3H`,
	"asset-detail__DrawerTitleContainer": `al7f61Cn6Z`,
	"asset-detail__DrawerTitleContainerText": `YLns8XpTEX`,
	"asset-detail__DrawerAdditionalContent": `UvcxjveqN2`,
	"asset-detail__DrawerAdvance": `eD0HlazzW5`,
	"drawer-header__close-btn": `yH8la806dK`,
	"pulse-icon-button__label": `h6d6S_ZJbz`,
	"header-title--primary": `HVTlQ_piIt`,
	"linkBtn": `Q6eM0pq8Rs`,
	"linkBtnIcon": `ZTyktRaY4O`,
	"linked-tasks": `omYuKbRwEW`,
	"linked-tasks__item": `rpBMnJsEQc`,
	"linked-tasks__label": `gEKAKLDz81`,
	"linked-tasks__more": `f8gfPVHOB1`,
	"linked-tasks__more-label": `fakTmoEeqU`,
	"linked-tasks__more-active": `Q6IvXuNunS`,
	"linked-tasks-with-more": `Cc60n1vcRA`,
	"linked-tasks__hiddenTippy": `FQOKxnE16u`,
	"hidden-task-tooltip": `f3x152c4Qc`,
	"linked-tasks__hiddenTippy-arrow": `gKHMw1k_Lo`
};
export default ___CSS_LOADER_EXPORT___;
